import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

/**
 * FontAwesome 아이콘 정의를 TinyMCE에서 사용할 수 있는 SVG 문자열로 변환
 * @param iconDefinition FontAwesome 아이콘 정의
 * @param size SVG 크기 (기본값: 24)
 * @returns SVG 문자열
 */
export function fontAwesomeToSvg(iconDefinition: IconDefinition, size: number = 24): string {
  const [width, height, , , svgPath] = iconDefinition.icon;
  
  return `<svg width="${size}" height="${size}" viewBox="0 0 ${width} ${height}"><path d="${svgPath}"/></svg>`;
}

/**
 * 여러 FontAwesome 아이콘을 TinyMCE 아이콘 객체로 변환
 * @param icons 아이콘 이름과 FontAwesome 정의의 매핑
 * @returns TinyMCE 아이콘 객체
 */
export function createTinyMCEIcons(icons: Record<string, IconDefinition>): Record<string, string> {
  const result: Record<string, string> = {};
  
  for (const [name, definition] of Object.entries(icons)) {
    result[name] = fontAwesomeToSvg(definition);
  }
  
  return result;
}